import { Sofa, Shield, Check, ArrowRight } from "lucide-react";

const homeStagingPoints = [
  "Möbel, Deko & Beleuchtung",
  "Visuelle Aufwertung der Räume",
  "Schnellere Vermarktung durch bessere Fotos",
];

const securityStagingPoints = [
  "Professionelle Funk-Alarmanlage inkl. Sensorik",
  "Schutz gegen Einbruch, Wasser & Feuer",
  "Bezugsfertige Sicherheit als Verkaufsargument",
];

export const ConceptSection = () => {
  return (
    <section id="security-staging" data-testid="concept-section" className="ss-section bg-white">
      <div className="ss-container">
        <div className="max-w-3xl">
          <span className="ss-eyebrow">Was ist Security Staging?</span>
          <h2 className="ss-h2 mt-4 text-slate-900" data-testid="concept-heading">
            Das Prinzip von Home Staging – nur mit{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Sicherheit statt Möbeln.</span>
              <span className="absolute left-0 right-0 bottom-1 h-3 bg-[var(--ss-gold)]/40 -z-0" aria-hidden="true" />
            </span>
          </h2>
          <p className="ss-lead mt-5">
            Traditionelles Home Staging inszeniert leere Wohnungen mit Möbeln und Deko, damit sie sich schneller verkaufen. <strong>Security Staging</strong> geht einen Schritt weiter: Wir statten Ihre leerstehende Immobilie mit einer vollständigen, professionellen <strong>Funk-Alarmanlage</strong> aus – als Schutzschild <em>und</em> als Premium-Verkaufsargument.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6" data-testid="concept-comparison">
          {/* Home Staging card */}
          <article className="ss-card !p-8 flex flex-col" data-testid="concept-home-staging">
            <div className="flex items-center gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-slate-100 text-slate-600">
                <Sofa className="h-5 w-5" />
              </span>
              <h3 className="ss-h3 text-slate-900">Klassisches Home Staging</h3>
            </div>
            <p className="mt-4 text-slate-600">
              Fokus auf visuelle Aufwertung: Möbel, Textilien, Beleuchtung. Ziel ist der emotionale Kaufimpuls.
            </p>
            <ul className="mt-5 space-y-2.5">
              {homeStagingPoints.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-slate-700">
                  <Check className="h-4 w-4 shrink-0 text-slate-400 mt-0.5" />
                  <span>{p}</span>
                </li>
              ))}
            </ul>
          </article>

          {/* Security Staging card - highlighted */}
          <article
            className="relative rounded-2xl bg-[#071A2B] text-white p-8 flex flex-col overflow-hidden border border-[var(--ss-gold)]/30 shadow-[0_20px_60px_rgba(7,26,43,0.25)]"
            data-testid="concept-security-staging"
          >
            <div className="absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[var(--ss-gold)]/10 blur-3xl" aria-hidden="true" />
            <div className="absolute right-4 top-4 ss-eyebrow-on-navy">Unser Konzept</div>

            <div className="relative flex items-center gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--ss-gold)] text-[var(--ss-navy)]">
                <Shield className="h-5 w-5" strokeWidth={2.5} />
              </span>
              <h3 className="ss-h3 text-white">Security Staging</h3>
            </div>
            <p className="relative mt-4 text-slate-300">
              Fokus auf Sicherheit &amp; Kaufargument: Vollständige Alarmanlage inkl. Sensorik &amp; App. Ziel: Vertrauen, Werterhalt und schnellerer Verkauf.
            </p>
            <ul className="relative mt-5 space-y-2.5">
              {securityStagingPoints.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-slate-200">
                  <Check className="h-4 w-4 shrink-0 text-[var(--ss-gold)] mt-0.5" strokeWidth={3} />
                  <span>{p}</span>
                </li>
              ))}
            </ul>

            <div className="relative mt-7 flex items-center gap-2 text-sm text-[var(--ss-gold)] font-semibold">
              Schnell. Spurlos. Effektiv. <ArrowRight className="h-4 w-4" />
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};
